import { useContext, useEffect, useRef } from 'react';
import { ServiceWorkerContext } from './ServiceWorkerContext';

export function useServiceWorker() {
    const context = useContext(ServiceWorkerContext);
    if (context === undefined) {
        throw new Error('useServiceWorker must be used within a ServiceWorkerProvider');
    }
    return context;
}
